import * as React from 'react';
import type { SVGProps } from 'react';
const SvgExplorer = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    viewBox="0 0 22 22"
    {...props}
  >
    <path d="m8.167 14.114.84-.52-1.523 3.876a1.05 1.05 0 1 0 1.955.767l1.361-3.465 1.36 3.465a1.05 1.05 0 0 0 1.956-.767l-1.581-4.025a2 2 0 0 0 .457-.201l3.671-2.163c-1.147-.313-2.403-1.274-3.343-2.684-1.11-1.665-1.475-3.496-1.056-4.72L8.62 5.824a2.1 2.1 0 0 0-.958 2.371L5.377 9.611a2.1 2.1 0 0 0-.973 2.084l-1.553.961a1.392 1.392 0 0 0 1.466 2.368l1.555-.963a2.1 2.1 0 0 0 2.295.053" />
    <path d="M18.903 9.817c1.159-.743 1.045-2.989-.255-5.016s-3.292-3.07-4.451-2.327-1.045 2.988.255 5.016 3.292 3.07 4.451 2.327" />
  </svg>
);
export default SvgExplorer;
